import { useQuery, useMutation } from "@apollo/client";
import { Button, Card, Col, Modal, Row, Typography, Form, Input, message } from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { GET_USER_NAME, GET_PRICE_PACKAGES } from "../../../Graphql/queries";
import Logo from "../../../Assets/Images/logo.png";
import { logout } from "../../../Utils/functions/common";
import { CustIcon } from "../../Svgs";
import "./ReplaceCardModal.less";
import {
  CardElement,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useStripe,
  Elements,
  useElements
} from "@stripe/react-stripe-js";
import { REPLACE_CARD } from '../../../Graphql/mutations';

const { Title } = Typography;

export const ReplaceCardModal = ({ customer, location, price, closeModal,cardId }) => {
  const { data: userNameData } = useQuery(GET_USER_NAME, {
    variables: { user_id: localStorage.getItem("user_id") },
  });
  const [
    REPLACECARD,
    { loading: isReplaceCardLoading },
  ] = useMutation(REPLACE_CARD);
  const stripe = useStripe();
  const elements = useElements();
  const [form] = Form.useForm();
  const layout = {
    labelCol: {
      span: 24,

    },
    wrapperCol: {
      span: 24,
    },
  };
  const onAddTransaction = async (ev) => {
  try {
    let additionalData = {
      locations: location.toString(),
      priceId: price,
      user_id: localStorage.getItem("user_id"),
      name: ev.card_name,
      customer_id: customer,
      old_card_id: cardId
    };
    if (!stripe || !elements) {
      return;
    }
    const response = await stripe.createToken(
      elements.getElement(CardNumberElement),
      additionalData,
    );
    if (response?.error || response?.token?.error) {
      message.error(response?.error?.message || response?.token?.error)
    } else {
      additionalData.token = response.token.id;
      const isReplaceSuccessfull = await REPLACECARD({
        variables: {
          stripe_data: additionalData
        }
      });
      if(isReplaceSuccessfull.data?.replace_card?.status === '200'){
        message.success('New Card added successfully!');
        closeModal();
      } else {
        message.error('Replace Card Failed...!');
        closeModal();
      }
    }
  } catch (error) {
    console.log(error);
  }
}
  const 
    style= {
      empty: {
      },
      base: {
        color: "#000",
        fontFamily: 'poppins, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: 15,
        '::placeholder': {
          color: '#92929ec2',
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a"
      }
    };

  const numberElement = {
    style: style,
    placeholder: 'Card Number',
    showIcon: true,
  }
  const expiryElement = {
    style: style,
    placeholder: 'MM / YY'
  }
  const cvvElement = {
    style: style,
    placeholder: 'CVV / CVC'
  }
  const handleChange = async (event) => {
    // Listen for changes in the CardElement
    // and display any errors as the customer types their card details
    // setDisabled(event.empty);
    // setError(event.error ? event.error.message : "");
  };
  return (
    <Modal
      centered
      visible
      footer={null}
      width={500}
      wrapClassName="replaceCardModelPOP"
    >
      
      <div className="replaceCardModel">
      <div className="text-right pb-3" onClick={closeModal}>
          <CustIcon type="close" />
        </div>
        <div className="replaceCardLogo">
          <img src={Logo} alt="" height={40} width={98}/>
        </div>
       <Title level={5} className="text-black font-weight-300 pt-2">
         Enter new card details
       </Title>
       <div className="text-black pb-5">
       Your new card payment will be pulled & will be effective from next billing cycle.
       </div>
     
       <Form {...layout} id="card-element" name="basic" form={form} onFinish={(e) => onAddTransaction(e)}>
    
    <Row className="mt-0 mx-0" gutter={16}>
    <Col xs={24} sm={24}>
                     <Form.Item
                    name="Card number"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please enter card number!",
                      //     whitespace: false,
                      //   },
                      // ]}
                  >
         <div className="inputCard"> <CardNumberElement id="card-element1" options={numberElement} onChange={handleChange} /> </div>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                  <Form.Item
                    name="Expiry"
                    // rules={[
                    //   {
                    //     required: false,
                    //     message: "Please enter expiry!",
                    //     whitespace: true,
                    //   },
                    // ]}
                  >
                 <div className="inputCard"> <CardExpiryElement id="card-element2" options={expiryElement} onChange={handleChange} /> </div> 
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="CVV/CVC"
                    // rules={[
                    //   {
                    //     required: false,
                    //     message: "Please enter cvv!",
                    //     whitespace: true,
                    //   },
                    // ]}
                  >
                  <div className="inputCard"> <CardCvcElement id="card-element3" options={cvvElement} onChange={handleChange} /> </div>
                  </Form.Item>
                </Col>
               <Col xs={24} sm={24}>
                  <Form.Item
                    name="card_name"
                    rules={[
                      {
                        required: true,
                        message: "Please enter name!",
                        whitespace: true,
                      },
                    ]}
                  >
                    <Input placeholder="e.g, John Doe" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24}>
                <Form.Item className="buttonSec pt-2">
              <Button
                type="primary"
                shape="round"
                size="large"
                htmlType="submit"
                className="w-100"
                loading={isReplaceCardLoading}
              >
                Save
              </Button>
            </Form.Item>
                </Col>
      </Row>
      </Form>
      </div>
    </Modal>
  );
};
